import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Maria K.',
      age: 67,
      city: 'München',
      rating: 5,
      text: 'Die Sterbegeld Experten haben uns wunderbar beraten. Sie nahmen sich viel Zeit, erklärten alles verständlich und gingen auf unsere Wünsche ein. Ich fühle mich jetzt sicher, dass meine Familie finanziell abgesichert ist. Sehr empfehlenswert!'
    },
    {
      name: 'Hans-Peter M.',
      age: 72,
      city: 'Solingen',
      rating: 5,
      text: 'Endlich mal jemand, der ehrlich berät! Keine versteckten Kosten, keine Gesundheitsprüfung. Alles transparent und fair. Nach 30 Minuten war alles geklärt. Vielen Dank für die kompetente Beratung!'
    },
    {
      name: 'Angelika S.',
      age: 58,
      city: 'Düsseldorf',
      rating: 5,
      text: 'Ich habe lange gezögert, mich mit dem Thema zu beschäftigen. Die Sterbegeld Experten machten es mir leicht – einfühlsam, professionell und ohne Druck. Jetzt bin ich erleichtert, dass alles geregelt ist. Absolute Empfehlung!'
    }
  ];

  return (
    <section className="section testimonials-section">
      <div className="container-custom">
        <div className="section-header fade-in">
          <h2 className="headline-secondary">Das sagen unsere Kunden</h2>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="testimonial-header">
                <div className="testimonial-info">
                  <h3>{testimonial.name}</h3>
                  <p className="testimonial-meta">{testimonial.age} Jahre, {testimonial.city}</p>
                </div>
                <div className="testimonial-stars">
                  {'★'.repeat(testimonial.rating)}
                </div>
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
            </div>
          ))}
        </div>

        <div className="testimonials-footer fade-in">
          <div className="google-mini-icon">
            <svg width="24" height="24" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              {/* Official Google G Icon */}
              <path fill="#4285F4" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"/>
              <path fill="#34A853" d="M6.3 14.7l6.6 4.8C14.4 16.1 18.7 13 24 13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 16.1 2 9.3 6.2 6.3 14.7z"/>
              <path fill="#FBBC05" d="M24 46c5.5 0 10.5-2 14.4-5.4l-6.7-5.2C29.6 37.1 26.9 38 24 38c-6.4 0-11.8-4.3-13.8-10.1l-6.5 5C6.6 40.9 14.4 46 24 46z"/>
              <path fill="#EA4335" d="M44.5 20H24v8.5h11.8c-.9 2.8-2.7 5.2-5.1 6.8l6.7 5.2c4.8-4.4 7.6-10.9 7.6-18.5 0-1.3-.2-2.7-.5-4z"/>
            </svg>
          </div>
          <p>Basierend auf 626 verifizierten Google-Bewertungen</p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
